export class ToastNotification {
  Type: string;
  Message: string;
  constructor(type: string, message: string) {
    this.Type = type;
    this.Message = message;
  }
}
